import Headers from '/src/_includes/graphql/catalog-service/headers.md';
import CustomerGroupCode from '/src/_includes/graphql/customer-group-code.md';
import Output from '/src/_includes/graphql/catalog-service/categories.md';
import * as React from 'react';
export default {
  Headers,
  CustomerGroupCode,
  Output,
  React
};